import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import HeaderBar from './HeaderBar';
import TopNavigation from './TopNavigation';
import AppFooter from './AppFooter';
import FloatingChat from '../FloatingChat';

const MainLayoutNew = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Cargando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="h-screen flex flex-col bg-gray-50">
      <HeaderBar />
      <TopNavigation />
      <main className="flex-1 overflow-y-auto">
        {children}
      </main>
      <AppFooter />
      <FloatingChat />
    </div>
  );
};

export default MainLayoutNew;